module.exports = __webpack_public_path__ + "fonts/Heebo-Regular.56936776.ttf";